var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video_page"},[_c('head-top',{attrs:{"head-title":"视频详情","goBack":"true"}}),_vm._v(" "),_c('div',{staticClass:"video_box"},[_c('video',{attrs:{"width":"100%","height":"240","controls":""}},[_c('source',{attrs:{"src":_vm.url,"type":"video/mp4"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2498022c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/videoPage.vue
// module id = u48l
// module chunks = 0